module.exports = __webpack_public_path__ + "img/HIW-PRICE-1-m.bd9edc00.png";